<template>
  <b-card
    no-body
    class="shadow-body"
  >
    <b-card-header>
      <b-card-title class="mb-1">
        {{ title }}
      </b-card-title>
    </b-card-header>
    <!-- chart -->
    <b-card-body>
      <chartjs-component-line-chart
        :height="400"
        :data="dataset"
        :options="chartjsData.lineChart.options"
        :plugins="plugins"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BCardHeader, BCardTitle,
} from 'bootstrap-vue'
import ChartjsComponentLineChart from './charts-components/ChartjsComponentLineChart.vue'
import chartjsData from './chartjsData'

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    ChartjsComponentLineChart,
  },
  props: {
    monthLineChartData: {
      type: [Object, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {},
    },
    title: {
      type: [String, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: '',
    },
  },
  data() {
    return {
      chartjsData,
      dataset: {},
      plugins: [
        // to add spacing between legends and chart
        {
          beforeInit(chart) {
            /* eslint-disable func-names, no-param-reassign */
            chart.legend.afterFit = function () {
              this.height += 20
            }
            /* eslint-enable */
          },
        },
      ],
    }
  },
  watch: {
    monthLineChartData: {
      immediate: true,
      deep: true,
      handler(val) {
        this.$set(this.dataset, 'labels', val.labels)
        this.$set(this.dataset, 'datasets', val.datasets)
      },
    },
  },
}
</script>
